import { render, staticRenderFns } from "./Version_Size.vue?vue&type=template&id=b6e4c044"
import script from "./Version_Size.vue?vue&type=script&lang=js"
export * from "./Version_Size.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports